import { mapMassMediaPostFields } from '@/adapters/media'
import { normalizeFilterParam } from '@/shared/utils'
import { directusClient, imageFields, readItems } from '@/shared/utils/directus'
import { IMassMediaPost } from '@/interfaces/media'

export interface GetMassMediaPostsParams {
  locale?: string
  category?: string | string[]
  page?: number
  limit?: number
}

export default async function getMassMediaPosts({
  locale = 'ru-RU',
  category,
  page = 1,
  limit = 12,
}: GetMassMediaPostsParams = {}) {
  const collectionName = 'mass_media_posts'

  const filter = {
    translations: { languages_code: { _eq: locale } },
    category: category ? { slug: { _in: normalizeFilterParam(category) } } : undefined,
  }

  try {
    const itemsRaw = await directusClient.request<Directus.MassMediaPost[]>(
      readItems(collectionName, {
        sort: ['-date_published'],
        page,
        limit,
        filter,
        deep: {
          translations: { _filter: { languages_code: { _eq: locale } } },
        },
        fields: [
          'url',
          'url_en',
          'date_published',
          {
            translations: ['title', 'excerpt', 'source'],
            image_preview: imageFields,
            image_preview_en: imageFields,
          },
        ],
      })
    )

    const aggregateCount = await directusClient.request<{ count: string }[]>(
      readItems(collectionName, {
        filter,
        aggregate: { count: '*' },
      })
    )

    const items = itemsRaw
      ?.map(item => {
        return mapMassMediaPostFields(item, locale)
      })
      ?.filter(Boolean) as IMassMediaPost[]

    return {
      items,
      page,
      limit,
      total: Number(aggregateCount?.[0]?.count) || 0,
    }
  } catch (error) {
    return {
      items: [],
      page,
      limit,
      total: 0,
    }
  }
}
